import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import UserContext from '../context/UserContext'
import arraste from '../imgs/arraste.png'

import { Main, Container, Voltar } from '../styles/GlobalStyled.js'

export default function Calibragem() {
  const { tamCartao, setTamCartao } = useContext(UserContext)
  return (
    <Main>
      <Container>
        <Cartao largura={`${tamCartao}px`}></Cartao>

        <Botoes>
          <img src={arraste} alt="arraste" />
          <input
            type="range"
            name="tamanho"
            min="100"
            max="350"
            step="1"
            value={tamCartao}
            onChange={(e) => setTamCartao(e.target.value)}
          />
          <Link to={'/medicao-com-anel'}>
            <button>Pronto, já calibrei!</button>
          </Link>
          <Link to={'/instrucao-calibragem'}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Botoes>
      </Container>
    </Main>
  )
}

const Cartao = styled.div`
  width: 100vw;
  height: ${(props) => props.largura};
  border-top: 5px solid #0d47a1;
  border-bottom: 5px solid #0d47a1;
  background-color: rgba(33, 150, 243, 0.4);
  position: absolute;
  top: 100px;

  @media (min-width: 1300px) {
    top: 5%;
  }
`

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 20px;
    background: rgba(33, 150, 243, 0.3);
    outline: none;
    width: 80vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #0d47a1;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #0d47a1;
    cursor: pointer;
  }

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 18px;
    color: #ffffff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    border-radius: 16px;
    font-weight: bold;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      -45deg,
      #2196f3,
      #0d47a1,
      #0d47a1 50%,
      #2196f3
    );
    &:hover {
      background-image: linear-gradient(
        90deg,
        #0d47a1,
        #2196f3,
        #2196f3 50%,
        #0d47a1
      );
      background-position: -100%;
    }
  }

  img {
    max-width: 150px;
    margin-left: -40vw;
    margin-bottom: -30px;
  }
`
